export default __webpack_public_path__ + "static/media/quick-link.0cc6854a.svg";